import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import MainLayout from '../../../components/MainLayout'
import ReactPaginate from "react-paginate";
import {TbClipboardCheck, TbLoader} from "react-icons/tb";
import {FiTrash2} from "react-icons/fi";
import {NumericFormat} from 'react-number-format';
import {HiOutlineDownload} from "react-icons/hi";
import Swal from "sweetalert2";
import TabAdminAaaver from '../ListadoAgentes/TabAdminAaaver';

import {
  deleteOneSolicitud,
  getAllAgentesList,
  getAllHistorySolicitudes,
} from "../../../helpers/Api";
import BadgePills from "../../../components/BadgePills";
import Select from "react-select";
import ListOptionsEstatus from '../../../helpers/ListOptionsEstatus';
import {CampoSelectAsync} from '../../../helpers/CampoSelectAsync';

const HistoricoGeneralSolicitudes = () => {

  //loaders
  const [loading, setLoading] = useState(true);
  //credentials
  const BASE_URL = process.env.REACT_APP_API;
  const token = localStorage.getItem("token");
  const role = localStorage.getItem('role');

  const [tableItemsCounter, setTableItemsCounter] = useState(0);
  const [solcititudes, setSolicitudes] = useState([]);
  //search
  const [searchParam, setSearchParam] = useState("");
  const [estatus, setEstatus] = useState('');
  const [search, setSearch] = useState('');
  const [agenteId, setAgenteId] = useState('')

  //pagination
  const itemsPerPage = 10;
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);


  useEffect(() => {
    getAllAgentes();
  }, [itemOffset, 
    searchParam, 
    estatus,
    search,
  ]);


  const getAllAgentes = async () => {
    try {
      const response = await getAllHistorySolicitudes(
        itemsPerPage,
        itemOffset,
        searchParam,
        estatus,
        agenteId,
        token
      );
      if (response) {
        response?.count === itemsPerPage
          ? setPageCount(1)
          : setPageCount(Math.ceil(response?.count / itemsPerPage));
          setSolicitudes(response.results);
          setTableItemsCounter(response.count)
      }
    } catch (error) {
      throw error;
    }
    finally {
      setLoading(false);
    }
  };

  const getAgentesCollection = async (search) => {
    try {
      const response = await getAllAgentesList(search, token);
      if (response) {
        return response
      }
    } catch (error) {
      throw error
    }
  }

  //Download Reportes
  const downLoadOperacionesAgencia = (filterRef, filterAgent, filterStatus ) => {
    fetch(`${BASE_URL}/generar-reporte-solicitudes-completas/?referencia=${filterRef}&agente=${filterAgent}&status=${filterStatus}`, {
       headers: {
      Authorization: `Token ${token}`,
    }
    }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "reporte-de-solicitudes.xlsx";
        a.click();
      });
    });
  };

  const handlePageClick = (event) => {
    setItemOffset(event.selected * itemsPerPage);
  };

  const handlerWordSearch = (e) => {
    setSearchParam(e.target.value);
  };

  const handlerEstatus = (e) => {
    setEstatus(e === null ? '' : e.value);
  };

  const handlerSelectAgente = (value) => {
    setSearch(value === null ? '' : {value: value.value, label:value.label });
    setAgenteId(value === null ? '' : value.value);
  }


  const handlerDeleteSolicitud = async (idSolicitud) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Una vez eliminado, no podrás recuperar esta referencia de solicitud!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteOneSolicitud(idSolicitud, token);
          if (!response) {
            Swal.fire("Exito", "La referencia ha sido borrado exitosamente", "success");
            getAllAgentes();
          }
        } catch (error) {
          Swal.fire(
            "Oops",
            "Ha surgido un problema al eliminar la referencia",
            "error"
          );
        }
      }
    });
  };

  return (
    <MainLayout>
    <div className="row title_layout">
      <div className="col-6">
        <h5>HISTÓRICO GENERAL DE SOLICITUDES</h5>
      </div>
      <div className="col-6 d-flex flex-row-reverse">
         <TabAdminAaaver />
      </div>
    </div>
    <div className="row table_body">
    { loading ? (
        <div className="d-flex justify-content-center" style={{marginTop: '4rem'}}>
            <TbLoader color={'rgb(10, 132, 254)'} className="loader" size={'3rem'}/>
        </div>
      ) : (
      <>
      <div className="row table_searchers">
        <div className="col-6 d-flex justify-content-start">
        { role !== 'NUS' &&
          <Link to="/crear-perfil-agente">
            <button className="btn principal_button">
              + Registrar Agente Aduanal
            </button>
          </Link>
        }
        </div> 
        <div className="col-6 d-flex justify-content-end">
        <button onClick={() => downLoadOperacionesAgencia(searchParam, agenteId, estatus)} className="btn lean_button">
            <HiOutlineDownload style={{marginRight: '10px'}} />
            Descargar Solicitudes
        </button>
        </div>
        <hr style={{ borderTop: "dotted 1px" }} />
        <div className="col-4">
          <input
            className="form-control"
            type="search"
            value={searchParam}
            onChange={handlerWordSearch}
            placeholder="Buscar por referencia"
            aria-label="Search"
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-4">
          <Select
              className="basic-single"
              classNamePrefix="select"
              name="filtro_estatus"
              options={ListOptionsEstatus}
              onChange={(e) => handlerEstatus(e)}
              placeholder={"Filtro por estatus"}
              isClearable={true}  
            />
        </div>
          <div className="col-4">
            <CampoSelectAsync
              blank={true}
              name="agencia_aduanal"
              fieldShow="nombre" 
              selectedValue={search} 
              remoteCall={getAgentesCollection}
              onChange={(key, value) => handlerSelectAgente(value)} 
              placeholder="Buscar por agente"                       
              />
          </div>
        {/* <div className="col-4">
          <Select
            className="basic-single"
            classNamePrefix="select"
            name="color"
            placeholder="Filtrar por estatus"
            options={ListOptionsEstatus}
            value={ListOptionsEstatus[0]}
          />
        </div> */}
        <hr style={{ borderTop: "dotted 1px", marginTop: "1rem" }} />
      </div>
      <div className="col-12 table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Referencia</th>
              <th scope="col">Bill of Landing</th>
              <th scope="col">Fecha de creación</th>
              <th scope="col">Naviera</th>
              <th scope="col">Contenedores</th>
              <th scope="col">Deuda USD</th>
              <th scope="col">Agente aduanal</th>
              <th scope="col">Estatus</th>
              {/* <th scope="col">Deuda</th> */}
              <th scope="col" style={{textAlign: 'center'}}>Acciones</th>
            </tr>
          </thead>
          {solcititudes?.map((value, index) => (
            <tbody key={index}>
              <tr>
                <td style={{paddingTop: '3.1rem'}}>{value.referencia}</td>
                <td style={{paddingTop: '3.1rem'}}>{value.numero_bl}</td>
                <td style={{paddingTop: '3.1rem'}}>{value.fecha_creacion}</td>
                <td style={{paddingTop: '3.1rem'}}>{value.naviera_nombre}</td>
                <td style={{paddingTop: '3.1rem'}}>{value.cantidad_contenedores_entregados} de {value.cantidad_contenedores}</td>
                <td style={{paddingTop: '3.1rem'}}>
                <NumericFormat 
                  prefix={"$"}
                  decimalSeparator={"."}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  displayType="text" 
                  value={value.total_demoras_pendiente} 
                  />
                </td>
                <td style={{paddingTop: '3.1rem'}}>{value.agencia_aduanal.nombre}</td>
                <td style={{paddingTop: '3.1rem'}}><BadgePills status={value.estado}/></td>
                {/* <td>{
                value.estado_deuda === 'BAJ'   ? 
                <BadgePills status={value.estado_deuda} amount={value.total_deuda}/> :
                value.estado_deuda === 'MED'   ? 
                <BadgePills status={value.estado_deuda} amount={value.total_deuda}/> :
                value.estado_deuda === 'ALT'   ? 
                <BadgePills status={value.estado_deuda} amount={value.total_deuda}/> :
                value.estado_deuda === 'MAL'   ? 
                <BadgePills status={value.estado_deuda} amount={value.total_deuda}/> :
                null
                }</td> */}
            
                <td className="d-flex flex-row" style={{height: '8.1rem'}}>
                  <button
                    style={{ color: "#F34949" }}
                    className="btn d-flex align-items-center"
                    onClick={() => handlerDeleteSolicitud(value.id)}
                  >
                    <FiTrash2 style={{marginLeft: '10px'}} size={'1.1rem'} />
                  </button>
                  <Link
                    className="btn d-flex align-items-center"
                    to={`/perfil-agente/${value.agencia_aduanal_id}/detalle-operaciones/${value.id}/#contenedores`}
                  >
                   <TbClipboardCheck 
                   size={'1.1rem'} 
                   color={"#4516FF"}/>
                  </Link>
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      </div>
      <div className="row">
      <div className="col-12" style={{textAlign: 'center', marginTop: '2rem'}}>
            <p>Total de solicitudes: {tableItemsCounter}</p>
          </div>
        <div className="col-12 d-flex justify-content-end paginationList">
          <ReactPaginate
            breakLabel="..."
            nextLabel="Siguiente"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="Anterior"
            renderOnZeroPageCount={null}
            containerClassName="pagination my-5 mx-auto"
            subContainerClassName="pages pagination"
            activeClassName="active"
            breakClassName="break-me"
            className="pagination"
          />
        </div>
      </div>
      </>
      )}
    </div>
  </MainLayout>
  )
}

export default HistoricoGeneralSolicitudes